import styled from 'styled-components';

export const Content = styled.div`
  width: 590px;
  position: relative;
`;